var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateReleases({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 111,
    viewBox: "0 0 118 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 42.2097C71.0812 42.2097 62.5612 41.8697 54.5912 39.6497C46.7712 37.4797 39.5912 33.2697 33.1912 28.3997C29.0012 25.2297 25.1912 22.7097 19.7512 23.0897C14.4247 23.3813 9.3336 25.3799 5.23121 28.7897C-1.68879 34.7897 -0.648793 46.0197 2.12121 53.9097C6.28121 65.7897 18.9412 74.0197 29.7012 79.3997C42.1312 85.6097 55.7912 89.2097 69.4812 91.2897C81.4812 93.1097 96.9012 94.4397 107.301 86.5997C116.851 79.3997 119.471 62.9597 117.131 51.8597C116.564 48.5776 114.818 45.6155 112.221 43.5297C105.511 38.6297 95.5012 41.8997 87.9612 42.0697C85.1612 42.1297 82.3112 42.1997 79.4512 42.2097Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9712 110.74C79.2456 110.74 95.6812 109.714 95.6812 108.45C95.6812 107.185 79.2456 106.16 58.9712 106.16C38.6969 106.16 22.2612 107.185 22.2612 108.45C22.2612 109.714 38.6969 110.74 58.9712 110.74Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4812 29.9897V34.2997",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3313 32.1497H98.6313",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2612 66.2097V70.5097",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1013 68.3597H26.4113",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2312 12.0697V16.3697",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0713 14.2197H20.3813",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0913 2.0897C65.6326 2.0897 66.0713 1.65094 66.0713 1.1097C66.0713 0.56846 65.6326 0.1297 65.0913 0.1297C64.5501 0.1297 64.1113 0.56846 64.1113 1.1097C64.1113 1.65094 64.5501 2.0897 65.0913 2.0897Z",
    fill: "#CFCFCF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7512 97.6897C63.2925 97.6897 63.7312 97.2509 63.7312 96.7097C63.7312 96.1684 63.2925 95.7297 62.7512 95.7297C62.21 95.7297 61.7712 96.1684 61.7712 96.7097C61.7712 97.2509 62.21 97.6897 62.7512 97.6897Z",
    fill: "#CFCFCF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7967 6.76622L26.7636 12.6902C25.4617 12.8254 24.5159 13.9905 24.6511 15.2924L32.4513 90.3884C32.5865 91.6903 33.7515 92.6361 35.0534 92.5008L92.0866 86.5768C93.3885 86.4416 94.3343 85.2766 94.1991 83.9747L86.3989 8.87868C86.2637 7.57677 85.0986 6.63099 83.7967 6.76622Z",
    fill: "#D2D2D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3426 10.2325L29.8695 15.579C28.5676 15.7142 27.6218 16.8793 27.7571 18.1812L34.8113 86.0958C34.9465 87.3977 36.1116 88.3435 37.4135 88.2083L88.8865 82.8618C90.1885 82.7266 91.1342 81.5615 90.999 80.2596L83.9448 12.345C83.8095 11.0431 82.6445 10.0973 81.3426 10.2325Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4613 13.5597L71.6613 5.85968C71.6212 5.54008 71.4573 5.24897 71.2049 5.04889C70.9525 4.84882 70.6316 4.75575 70.3113 4.78968L60.7913 5.78968C60.7138 5.02144 60.4858 4.276 60.1202 3.59589C59.7546 2.91579 59.2587 2.31435 58.6607 1.82591C58.0627 1.33747 57.3743 0.971607 56.6349 0.7492C55.8955 0.526792 55.1195 0.452197 54.3513 0.529677C53.5831 0.607157 52.8376 0.835192 52.1575 1.20076C51.4774 1.56634 50.876 2.06229 50.3875 2.6603C49.4011 3.86803 48.9348 5.41816 49.0913 6.96968L39.5413 7.96968C39.3804 7.98592 39.2242 8.03375 39.0818 8.11042C38.9394 8.18709 38.8134 8.2911 38.7113 8.4165C38.6091 8.5419 38.5327 8.68622 38.4863 8.8412C38.44 8.99618 38.4247 9.15878 38.4413 9.31968L39.2413 17.0197C39.2575 17.1806 39.3054 17.3368 39.382 17.4792C39.4587 17.6216 39.5627 17.7475 39.6881 17.8497C39.8135 17.9519 39.9579 18.0283 40.1128 18.0746C40.2678 18.121 40.4304 18.1363 40.5913 18.1197L71.3713 14.9197C71.5328 14.9036 71.6895 14.8554 71.8321 14.7779C71.9748 14.7005 72.1005 14.5954 72.2021 14.4687C72.3036 14.342 72.3788 14.1964 72.4233 14.0403C72.4678 13.8842 72.4807 13.7208 72.4613 13.5597Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateReleases);
export default __webpack_public_path__ + "static/media/empty-state-releases.acc4bf88bb92b1a8d429d5042f880494.svg";
export { ForwardRef as ReactComponent };